/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

// ip格式校验
export function isIP(value) {
  return /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/.test(value)
}
// 邮箱格式校验
export function isMaill(value) {
  return /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(value)
}
// 身份证格式校验
export function isID(value) {
  return /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(value)
}
// 电话格式校验
export function isPhone(value) {
  return /^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(value)
}
// 密码格式校验
export function isPassword(value) {
  return /^[a-zA-Z]\w{5,17}$/.test(value)
}
// 只能输入数字
export function isNumber(value) {
  return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(value)
}
// 英文格式校验
export function isEnglish(value) {
  return /^[a-zA-Z]+$/.test(value)
}
// 只能正整数
export function isNumberg(value) {
  return /^[0-9]*[1-9][0-9]*$/g.test(value)
}

/**
 * @param {string} str
 * @returns {Boolean}
 */
export function validUsername(str) {
  const valid_map = ['admin', 'editor']
  return valid_map.indexOf(str.trim()) >= 0
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
  if (!str || str === 'undefined' || str === 'null') {
    return ''
  }
  return str
}
// 表单重置
export function resetForm(refName) {
  if (this.$refs[refName]) {
    this.$refs[refName].resetFields();
  }
}
// 原权限按钮控制
export function doesItContain(V = []) {
  const url = window.sessionStorage.getItem("userRoleId");
  const newUrl = url.split(',')
  const roId = []
  newUrl.map((e) => {
    roId.push(Number(e))
  })
  if (!url) {
    return false
  } else {
    return V.filter((el) => roId.includes(el));
  }
}

export function timestampToYYYYMMDD(timestamp) {
  // 使用Intl.DateTimeFormat
  let dateFormat = new Intl.DateTimeFormat('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(timestamp);

  return dateFormat;
}

/**
 * el-table-column 的 formatter：把 "2026-09-15 15:43:51" 拆成「日期 / 时间」两行显示。
 * 日期与时间之间插入换行符，配合 index.scss 中 `.el-table td.cell-two-line .cell { white-space: pre-line }` 生效。
 *
 * ★ 注意 element-ui 的一个坑：列里只要写了 <template slot-scope>，element-ui 就会跳过 formatter
 *   （table-column.js 的 renderCell：有 $scopedSlots.default 就不调用 originRenderCell），
 *   此时本函数根本不会被调用、\n 也不会产生。
 *   因此 index.scss 里那条规则额外加了 `word-break: normal`，让这类列直接靠浏览器在
 *   「日期 时间」之间的空格处断行 —— 也就是说：只要列上有 class-name="cell-two-line" 就够了，
 *   formatter 只是「即便列很宽也强制两行」的加强项。
 */
export function dateTimeTwoLine(row, column, cellValue) {
  if (cellValue === null || cellValue === undefined || cellValue === '') {
    return cellValue;
  }
  const text = String(cellValue).trim();
  const i = text.indexOf(' ');
  return i > 0 ? text.slice(0, i) + '\n' + text.slice(i + 1).trim() : text;
}
